// App.js

import React, { useState, useEffect } from 'react';
import './App.css';
import BoxGlasses from './primaryPanel/BoxGlasses';
import ParallaxModal from './secondaryPanel/ParallaxModal';
import { GlobalProvider } from './main/GlobalContext';
import { useMouseEffects } from './main/MouseEffects';
import ContentSelect from './main/ContentSelect';
import EthereumContext from './blockchain/EthereumContext';
import WalletConnect from './blockchain/WalletConnect';
import './i18n';

function App() {
  const [showBoxGlasses, setShowBoxGlasses] = useState(false);
  const [showParallaxModal, setShowParallaxModal] = useState(false);
  const [currentParallaxCategory, setCurrentParallaxCategory] = useState('');
  const [sceneType, setSceneType] = useState('');
  const [modelName, setModelName] = useState('');
  const [color, setColor] = useState(''); // Nouvel état pour le coloris
  const pointerRef = useMouseEffects();
  const [provider, setProvider] = useState(null);
  const [account, setAccount] = useState('');
  const [networkName, setNetworkName] = useState('');

  const handleModelChange = (newSceneType, newModelName) => {
    setSceneType(newSceneType);
    setModelName(newModelName);
    setColor(newSceneType); // Capturer le coloris ici
    setShowBoxGlasses(true);
  };

  const handleParallaxModalShow = (sceneName) => {
    setCurrentParallaxCategory(sceneName);
    setShowParallaxModal(true);
  };

  // Récupérer l'adresse du portefeuille lorsque le provider change
  useEffect(() => {
    const getAccount = async () => {
      if (provider) {
        try {
          const signer = await provider.getSigner();
          const address = await signer.getAddress();
          setAccount(address);
        } catch (error) {
          console.error('Erreur lors de la récupération de l\'adresse du portefeuille:', error);
        }
      }
    };
    getAccount();
  }, [provider]);

  return (
    <EthereumContext.Provider
      value={{
        provider,
        setProvider,
        account,
        setAccount,
        networkName,
        setNetworkName,
      }}
    >
      <GlobalProvider>
        <div className="App">
          <div ref={pointerRef} className="custom-pointer"></div>
          <WalletConnect />
          {/* Composant ContentSelect pour gérer les changements de modèles et scènes */}
          <ContentSelect
            onModelChange={handleModelChange}
            onParallaxModalShow={handleParallaxModalShow}
          />
          {showBoxGlasses && (
            <BoxGlasses
              isOpen={showBoxGlasses}
              onClose={() => setShowBoxGlasses(false)}
              sceneType={sceneType}
              modelName={modelName}
              color={color} // Utilisation de l'état color
            />
          )}
          {showParallaxModal && (
            <ParallaxModal
              isOpen={showParallaxModal}
              onClose={() => setShowParallaxModal(false)}
              category={currentParallaxCategory}
              modelName={modelName}
            />
          )}
        </div>
      </GlobalProvider>
    </EthereumContext.Provider>
  );
}

export default App;